import { Link } from "@inertiajs/react"

export function TermsBanner() {
    return (
        <div
            className="flex flex-col items-center justify-center h-auto sm:h-[310px] p-4"
            style={{
                background: `url('/images/static/Banner-half-FirearmLand.webp') no-repeat center`,
                backgroundSize: "cover",
            }}
        >
            <span className="text-white text-sm sm:text-[15px] mb-2">
                FIREARMLAND
            </span>
            <div className="text-white text-2xl  lg:leading-[3rem] sm:text-4xl font-medium mb-2">
                Discover the perfect gun for your needs.
                <br />
                Your next firearm adventure starts here!
            </div>
            <Link
                href="/"
                className="px-4 py-2 text-[#FF0000] text-xs sm:text-base"
            >
                Start Now
            </Link>
        </div>
    )
}
